import flatpickr from "flatpickr"
import l10n from "flatpickr/dist/l10n"

// Month and weekday names follow the page language (<html lang>, set from
// I18n.locale), so a DiDi customer who picked Spanish no longer sees a
// Portuguese calendar. Unknown codes fall back to English.
function pageLocale() {
  const lang = (document.documentElement.lang || "en").toLowerCase().split(/[-_]/)[0];
  return l10n[lang] || l10n.default;
}

flatpickr(".datepicker", {
  altInput: true,
  "locale": pageLocale()
});


// Function to get the current time in Brazil (São Paulo, UTC-3)
function getBrazilTime() {
  // Brazil Standard Time (GMT-3)
  return new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" });
}

// Piktiz does not operate on Sundays — no photographer dispatch runs, so no
// customer may land a session on one, whatever the industry. Mirrored
// server-side by Shooting#date_is_not_sunday (app/models/shooting.rb), which
// refuses a Sunday on every customer booking context even if this picker is
// bypassed. Greying the day out here is the UX half, not the enforcement.
const SUNDAY = 0;
function isClosedDay(date) {
  return date.getDay() === SUNDAY;
}

// Calculate the minDate based on the current time in Brazil.
// `extraBufferDays` ADDS to the natural day-of-week increment (e.g. food
// enterprises pass 3 to get "real-estate-style natural increment + 3 days
// of restaurant prep lead time"). Pass 0 (or omit) to use the bare natural
// increment — that's what every non-food vertical gets.
// `fridayToTuesday` (DiDi) replaces all of that on a Friday: whatever the
// hour, the first bookable day is the Tuesday after. Mirrors
// Shooting.food_lead_days_for.
const FRIDAY = 5;
const FRIDAY_TO_TUESDAY_DAYS = 4;
function calculateMinDate(extraBufferDays = 0, fridayToTuesday = false) {
  let brazilTime = new Date(getBrazilTime());
  let dayOfWeek = brazilTime.getDay();
  let hour = brazilTime.getHours();

  // NOTE: these branches read TODAY's weekday to size the lead time. They do
  // NOT filter which weekdays are selectable — that's what `disable` below is
  // for. Keeping the two concerns separate is why Sundays stayed bookable for
  // so long: this looked like weekend handling but only ever moved the floor.
  let minDateIncr = 2; // Default increment is 2 days
  if (dayOfWeek === 6) { // Saturday
      minDateIncr = 3;
  } else if (dayOfWeek === 5 && hour >= 17) { // Friday after 17:00
      minDateIncr = 4;
  } else if (dayOfWeek === 0 || hour >= 17) { // Sunday or any day after 17:00
      minDateIncr = 2;
  } else if (hour < 17) { // Any day before 17:00
      minDateIncr = 1;
  }

  let leadDays = minDateIncr + extraBufferDays;
  if (fridayToTuesday && dayOfWeek === FRIDAY) {
    leadDays = FRIDAY_TO_TUESDAY_DAYS;
  }

  let minDate = new Date().fp_incr(leadDays);
  // Never hand back a closed day as the calendar's floor — it's disabled, so
  // opening the picker on it would show an unselectable first available day.
  while (isClosedDay(minDate)) {
    minDate = minDate.fp_incr(1);
  }
  return minDate;
}

// Initialize one picker per element so per-input data-min-buffer-days is honored.
// Value is now "extra days added on top of the natural day-of-week increment"
// — see calculateMinDate above. Food enterprises pass 3 (DiDi 2, plus
// data-friday-to-tuesday).
document.querySelectorAll(".datebriefpicker").forEach(function(el) {
  let buffer = parseInt(el.dataset.minBufferDays || "0", 10);
  if (isNaN(buffer)) buffer = 0;
  let minDate = calculateMinDate(buffer, el.dataset.fridayToTuesday === "true");
  flatpickr(el, {
    altInput: true,
    altFormat: "l d M y",
    minDate: minDate,
    maxDate: new Date().fp_incr(20),
    // Sundays are greyed out and unclickable in every booking picker this
    // class is on — direct booking, Uber/DiDi partner form, real-estate
    // (Sua Quadra) scheduling, rescheduling and bulk-booking rows.
    disable: [isClosedDay],
    label_html: { class: "form-label text-secondary fw-bold" },
    "locale": pageLocale(),
    // Open the calendar on the month of the first available day, not on
    // "today". Matters when the buffer pushes the floor into next month —
    // food enterprise on a Friday evening lands in the following week,
    // sometimes crossing a month boundary.
    onOpen: function(selectedDates, _dateStr, instance) {
      if (selectedDates.length === 0) {
        instance.jumpToDate(minDate);
      }
    }
  });
});


// FlatPicker for ranges
flatpickr(".date-range", {
  mode: "range",
  dateFormat: "Y-m-d", // You can change the format as needed
  onChange: function(selectedDates, dateStr, instance) {
      console.log(selectedDates); // Selected dates array
      console.log(dateStr);       // Formatted date string
  }
});
